import styled from 'styled-components'

export const CategoryDescription = styled('p')`
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  margin: 0px;
`